export const ADD_GAMES_DATA = 'ADD_GAMES_DATA';
export const RESET_GAMES_DATA = 'RESET_GAMES_DATA';

const INITIAL_STATE = {
  games: [],
  isLoaded: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_GAMES_DATA:
      return {
        games: action.payload,
        isLoaded: true,
      };
    case RESET_GAMES_DATA:
      return {
        games: action.payload,
        isLoaded: false,
      };
    default:
      return state;
  }
}

export function addGamesData(games) {
  return { type: ADD_GAMES_DATA, payload: games };
}

export function resetGamesData() {
  return { type: RESET_GAMES_DATA, payload: [] };
}
